"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BitbucketCloneIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 3.999H4.995A2 2 0 0 0 3 6.007v7.983c0 1.107.893 2.008 1.995 2.008h14.01A2 2 0 0 0 21 13.99V6.007a2.004 2.004 0 0 0-1.995-2.008H16v2h3v8H5v-8h3z"/><path d="M10 16.998h4v3h-4z"/><path d="M9 20a1 1 0 0 1 .99-1h4.02c.55 0 .99.44.99 1v1H9zm.29-11.71a1 1 0 0 0 0 1.42l2 2c.2.2.45.3.71.3.25 0 .51-.1.71-.3l2-2A1 1 0 1 0 13.3 8.3L12 9.59 10.71 8.3a1 1 0 0 0-1.41 0"/><rect width="2" height="7" x="11" y="2.998" rx="1"/></g></svg>`
}, props));
BitbucketCloneIcon.displayName = 'BitbucketCloneIcon';
var _default = exports.default = BitbucketCloneIcon;